import {
    createSelector
} from 'reselect';

export const getEditingArticle = createSelector(
    (state) => state.blogState.isEditing,
    (_, props) => props.children,
    (isEditing, article) => (isEditing ? {} : article || {})
);
